import React from "react";
import PageTranslations from "./PageTranslations";

const CommonEbookTooling = ({ bookId, pageId }) => {
  return (
    <>
      <PageTranslations bookId={bookId} pageId={pageId} />
    </>
  );
};

export default CommonEbookTooling;
